import { format, toZonedTime } from 'date-fns-tz';
import type { YAxisPlotLinesOptions } from 'highcharts';

const getChartValue = (t: (text: string) => string, pointType: string, value?: null | number) => {
  if (pointType === 'boolean') {
    return t(value ? 'Open' : 'Close');
  }

  return value;
};

export const getChartRmsOptions = (
  t: (text: string) => string,
  chartData: Array<[number, number]>,
  pointType: string,
  dateFormat: string,
  maxChartYValue: number | null,
  alertPLotLines?: Array<YAxisPlotLinesOptions>,
  unit?: string,
  isDarkMode?: boolean,
) => {
  if (!chartData.length) {
    return {};
  }

  const chartOptions: Highcharts.Options = {
    chart: {
      style: { fontFamily: 'Roboto, sans-serif', fontSize: '12px' },
      height: 295,
      zooming: { type: 'xy' },
      backgroundColor: 'none',
    },
    title: { text: '' },
    legend: { enabled: false },
    credits: { enabled: false },
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    plotOptions: { line: { marker: { enabled: false } }, spline: { marker: { enabled: false } } },
    series: [
      {
        type: pointType === 'boolean' ? 'line' : 'spline',
        data: chartData || [],
        color: isDarkMode ? '#4A91C3' : '#1F77B4',
        lineWidth: 1,
        step: pointType === 'boolean' ? 'center' : undefined,
      },
    ],
    xAxis: [
      {
        type: 'datetime',
        labels: {
          style: {
            fontSize: '12px',
            color: isDarkMode ? '#797F89' : '#b6bbc7', //--inputs-default-placeholder,
          },
        },
        lineWidth: 0,
        tickLength: 0,
      },
    ],
    yAxis:
      pointType === 'boolean'
        ? [
            {
              max: 1,
              labels: {
                style: {
                  fontSize: '12px',
                  color: isDarkMode ? '#797F89' : '#b6bbc7', //--inputs-default-placeholder,
                },
                step: 2,
                formatter: function () {
                  return t(this.value === 1 ? 'Open' : 'Close');
                },
              },
              gridLineColor: isDarkMode ? '#595959cc' : '#ededef',
            },
          ]
        : [
            {
              title: undefined,
              labels: {
                style: {
                  fontSize: '12px',
                  color: isDarkMode ? '#797F89' : '#b6bbc7', //--inputs-default-placeholder,
                },
              },
              plotLines: alertPLotLines || [],
              max: maxChartYValue || maxChartYValue === 0 ? maxChartYValue * 1.1 : null,
              gridLineColor: isDarkMode ? '#595959cc' : '#ededef',
            },
          ],
    tooltip: {
      style: {
        fontSize: '12px',
      },
      formatter: function () {
        return `${format(toZonedTime(this.x || '', ''), dateFormat)} ${getChartValue(t, pointType, this.y)} ${
          unit || ''
        }`;
      },
    },
  };

  return chartOptions;
};
